<svg xmlns="http://www.w3.org/2000/svg" viewBox="2 2 28 28" role="img" aria-label="Atomic Lab">
  <title>Atomic Lab</title>
  <!-- glass (white, so the mark reads on dark tabs too) -->
  <path d="M13 6v7.2L6.6 24.6A3 3 0 0 0 9.2 29h13.6a3 3 0 0 0 2.6-4.4L19 13.2V6z" fill="#FFFFFF"/>
  <!-- liquid -->
  <path d="M9.2 19.6h13.6l2.6 5A3 3 0 0 1 22.8 29H9.2a3 3 0 0 1-2.6-4.4z" fill="#4262FF"/>
  <!-- bubbles -->
  <circle cx="13.6" cy="24.4" r="1.4" fill="#FFFFFF"/>
  <circle cx="18.4" cy="22.4" r="1" fill="#FFFFFF"/>
  <circle cx="17.4" cy="26.2" r="0.8" fill="#FFFFFF"/>
  <circle cx="16" cy="15.6" r="1" fill="#4262FF"/>
  <circle cx="17.3" cy="11.4" r="0.7" fill="#4262FF"/>
  <!-- outline and rim -->
  <path d="M13 6v7.2L6.6 24.6A3 3 0 0 0 9.2 29h13.6a3 3 0 0 0 2.6-4.4L19 13.2V6" fill="none" stroke="#1A1A1A" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>
  <rect x="11" y="3" width="10" height="3" rx="1.5" fill="#1A1A1A"/>
</svg>
